import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Popover from '@material-ui/core/Popover';
import { getLocalizedName, getFileURL } from '../../helpers';
import { getIconForFileExtension } from './FileHelper';
import './HomeResultsComponents.css';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import backgroundPattern from '../Library/images/background-pattern.png';
import AppContext from '../../AppContext';

const PlayArrowIcon = 'md-play-arrow';
const InfoIcon = 'md-info';
// const PauseIcon = 'md-pause';

const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundPattern})`,
};

export class Content extends Component {
    static propTypes = {
        resource: PropTypes.object.isRequired,
        onItemClick: PropTypes.func.isRequired,
        style: PropTypes.object,
        embeded: PropTypes.bool,
    };

    handleClick = (evt) => {
        this.props.onItemClick(this.props.resource, evt, 's');
    };

    render() {
        let src = this.props.resource.image ? getFileURL(this.props.resource.image) : undefined;
        let language = new AppContext().getLanguage();
        let title = getLocalizedName(language, this.props.resource.title);
        let highlights = this.props.resource.highlights;
        return (
            <GridListTile
                data-id={this.props.resource.resourceId}
                data-type="home-search-result-content"
                cols={1}
                rows={1}
                onClick={this.handleClick}
                classes={{ tile: 'pdc-search-results-item' }}
                {...{ style: { ...this.props.style, cursor: 'pointer' } }}
            >
                {src ? (
                    <img src={src} alt={title} style={imgStyle} />
                ) : (
                    <div
                        style={{
                            height: '100%',
                            width: '100%',
                            backgroundColor: '#f5f5f5',
                        }}
                    />
                )}
                <GridListTileBar
                    title={
                        <div className="pdc-search-results-title-container">
                            <div className="pdc-search-results-title-text">{title}</div>
                            <div className="pdc-search-results-title-icon">
                                <HighlightingPopover embeded={this.props.embeded}  highlights={highlights} />
                            </div>
                        </div>
                    }
                />
            </GridListTile>
        );
    }
}

export class Image extends Component {
    static propTypes = {
        resource: PropTypes.object.isRequired,
        onItemClick: PropTypes.func.isRequired,
        style: PropTypes.object,
        embeded: PropTypes.bool,
    };

    handleClick = (evt) => {
        this.props.onItemClick(this.props.resource, evt, 's');
    };

    render() {
        let src = getFileURL(this.props.resource.resourceId);
        let language = new AppContext().getLanguage();
        let title = getLocalizedName(language, this.props.resource.title);
        let highlights = this.props.resource.highlights;
        return (
            <GridListTile
                data-id={this.props.resource.resourceId}
                data-type="home-search-result-image"
                cols={1}
                rows={1}
                onClick={this.handleClick}
                classes={{ tile: 'pdc-search-results-item' }}
                {...{ style: { ...this.props.style, cursor: 'pointer' } }}
            >
                <img src={src} alt={title} style={imgStyle} />
                <GridListTileBar
                    title={
                        <div className="pdc-search-results-title-container">
                            <div className="pdc-search-results-title-text">{title}</div>
                            <div className="pdc-search-results-title-icon">
                                <HighlightingPopover embeded={this.props.embeded}  highlights={highlights} />
                            </div>
                        </div>
                    }
                />
            </GridListTile>
        );
    }
}

const arrowContainerStyle = {
    position: 'absolute',
    top: 'calc(50% - 35px)',
    left: 'calc(50% - 25px)',
    width: '40px',
    height: '40px',
    color: 'white',
    cursor: 'pointer',
    backgroundColor: 'rgba(255,255,255,0.5)',
    borderRadius: '100%',
    padding: '5px',
};
const arrowStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width: '20px',
    height: '20px',
    color: 'black',
    cursor: 'pointer',
};
export class Video extends Component {
    static propTypes = {
        resource: PropTypes.object.isRequired,
        onItemClick: PropTypes.func.isRequired,
        style: PropTypes.object,
        embeded: PropTypes.bool,
    };

    state = {
        // playing: false
    };

    handleClick = (evt) => {
        evt.stopPropagation();
        this.props.onItemClick(this.props.resource, evt, 's');
    };

    // playPause = evt => {
    //     evt.stopPropagation();
    //     if (this.videoPlayer.paused) {
    //         this.videoPlayer.play();
    //         this.setState({ playing: true });
    //     } else {
    //         this.videoPlayer.pause();
    //         this.setState({ playing: false });
    //     }
    // };

    render() {
        let image = this.props.resource.image ? getFileURL(this.props.resource.image) : undefined;
        let src = getFileURL(this.props.resource.resourceId);
        let language = new AppContext().getLanguage();
        let title = getLocalizedName(language, this.props.resource.title);
        let highlights = this.props.resource.highlights;
        return (
            <GridListTile
                data-id={this.props.resource.resourceId}
                data-type="home-search-result-video"
                cols={1}
                rows={1}
                onClick={this.handleClick}
                classes={{ tile: 'pdc-search-results-item' }}
                {...{ style: { ...this.props.style, cursor: 'pointer' } }}
            >
                <video
                    alt={title}
                    style={imgStyle}
                    poster={image}
                    // ref={video => {
                    //     this.videoPlayer = video;
                    // }}
                    // preload="metadata"
                    // controls
                >
                    <source src={src} type="video/mp4" />
                    {'Your browser does not support HTML5 video.'}
                </video>
                <div style={arrowContainerStyle} onClick={this.handleClick}>
                    {/*    {this.state.playing ? (
                        <div style={arrowStyle}>
                            <Icon
                                name={PauseIcon}
                                size={arrowStyle.height}
                                primaryColor={arrowStyle.color}
                                secondaryColor={'#000'}
                            />
                        </div>
                    ) :
                        (*/}
                    <div style={arrowStyle}>
                        <Icon name={PlayArrowIcon} size={arrowStyle.height} primaryColor={arrowStyle.color} secondaryColor={'#000'} />
                    </div>
                    {/*         )}*/}
                </div>
                <GridListTileBar
                    title={
                        <div className="pdc-search-results-title-container">
                            <div className="pdc-search-results-title-text">{title}</div>
                            <div className="pdc-search-results-title-icon">
                                <HighlightingPopover embeded={this.props.embeded}  highlights={highlights} />
                            </div>
                        </div>
                    }
                />
            </GridListTile>
        );
    }
}

// const fileIconStyle = {
//     width: '20px',
//     height: 'auto',
//     marginLeft: 'auto',
//     marginRight: 'auto',
//     marginTop: '10%',
// };
export class File extends Component {
    static propTypes = {
        resource: PropTypes.object.isRequired,
        onItemClick: PropTypes.func.isRequired,
        style: PropTypes.object,
        embeded: PropTypes.bool,
    };

    handleClick = (evt) => {
        this.props.onItemClick(this.props.resource, evt, 's');
    };

    render() {
        const imgStyle = {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover',
            backgroundImage: `url(${backgroundPattern})`,
        };
        let image = this.props.resource.image ? getFileURL(this.props.resource.image) : undefined;
        if (image) {
            imgStyle.backgroundImage = `url(${image})`;
        }
        let language = new AppContext().getLanguage();
        let aux = getLocalizedName(language, this.props.resource.title).split('.');
        let extension = aux[aux.length - 1];
        let icon = getIconForFileExtension(extension);
        let title = getLocalizedName(language, this.props.resource.title);
        let highlights = this.props.resource.highlights;
        return (
            <GridListTile
                data-id={this.props.resource.resourceId}
                data-type="home-search-result-file"
                cols={1}
                rows={1}
                onClick={this.handleClick}
                classes={{ tile: 'pdc-search-results-item' }}
                {...{ style: { ...this.props.style, cursor: 'pointer' } }}
            >
                {image ? (
                    // <img src={image} alt={title} style={imgStyle} />
                    <div style={imgStyle} />
                ) : (
                    <div
                        style={{
                            height: '100%',
                            width: '100%',
                            backgroundColor: '#f5f5f5',
                            backgroundImage: `url(${icon})`,
                            backgroundSize: 'auto 50%',
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat no-repeat',
                        }}
                    >
                        {/* <img src={icon} alt={title} style={fileIconStyle} /> */}
                    </div>
                )}
                {/* <div style={{ width: '100%', height: 'auto', textAlign: 'center' }}>
                    {image === undefined && <img src={icon} alt={title} style={fileIconStyle} />}
                    {image !== undefined && <img src={image} alt={title} style={fileIconStyle} />}
                    <HighlightingPopover embeded={this.props.embeded}  highlights={highlights} />
                </div> */}
                <GridListTileBar
                    title={
                        <div className="pdc-search-results-title-container">
                            <div className="pdc-search-results-title-text">{title}</div>
                            <div className="pdc-search-results-title-icon">
                                <HighlightingPopover embeded={this.props.embeded}  highlights={highlights} />
                            </div>
                        </div>
                    }
                />
                {/* <div
                    className="pdc-search-results-title-container-file"
                    style={{
                        width: 'calc(100% - 30px)',
                        wordWrap: 'break-word',
                        fontWeight: 'bold',
                        fontSize: '10px',
                        margin: '15px',
                        marginTop: '0px',
                        position: 'relative',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            maxHeight: '100%',
                        }}
                    >
                        {title}
                    </div>
                </div> */}
            </GridListTile>
        );
    }
}

class HighlightingPopover extends Component {
    static propTypes = {
        highlights: PropTypes.string.isRequired,
        embeded: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    handleClick = (event) => {
        //event.preventDefault();
        event.stopPropagation();
        this.setState({
            open: !this.state.open,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = (evt) => {
        evt.stopPropagation();
        this.setState({
            open: false,
            anchorEl: undefined,
        });
    };

    getHighlightElement(highlights) {
        if (highlights.indexOf('<em>') !== -1) {
            let aux = highlights.split('<em>');
            let partOne = aux[0];
            let subaux = aux[1].split('</em>');
            let high = subaux[0];
            let finalPart = subaux[1];
            return (
                <div>
                    {partOne}
                    <b>{high}</b>
                    {finalPart}
                </div>
            );
        }
        return undefined;
    }

    render() {
        return (
            <div>
                <div
                    style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                    }}
                    // onClick={() => console.log('què polles passa?')}
                >
                    <IconButton name={InfoIcon} onClick={this.handleClick} />
                </div>

                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    onClose={this.handleRequestClose}
                    style={{ maxWidth: '500px' }}
                    disablePortal={this.props.embeded === true}
                >
                    <div style={{ padding: '15px' }}>{this.getHighlightElement(this.props.highlights)}</div>
                </Popover>
            </div>
        );
    }
}
